function parseStringData(data) {
  return JSON.parse(data)
}

export default parseStringData
